<template>
  <div>
    <BaseButton>保存</BaseButton>
    <BaseButton :disabled="true">保存</BaseButton>

    <div class="block">
      <BaseButton1>BaseButton1</BaseButton1>
      <BaseButton1 :disabled="true">BaseButton1</BaseButton1>
      <BaseButton1 :type="1">BaseButton1</BaseButton1>
      <BaseButton1 :type="1" :disabled="true">BaseButton1</BaseButton1>
      <BaseButton1 :type="2">BaseButton1</BaseButton1>
      <BaseButton1 :type="2" :disabled="true">BaseButton1</BaseButton1>
      <BaseButton1 :type="3">BaseButton1</BaseButton1>
      <BaseButton1 :type="3" :disabled="true">BaseButton1</BaseButton1>
      <BaseButton1 :type="4">BaseButton1</BaseButton1>
      <BaseButton1 :type="4" :disabled="true">BaseButton1</BaseButton1>
    </div>

    <div class="block">
      <BaseButton2>Base2Button</BaseButton2>
      <BaseButton2 :disabled="true">BaseButton2</BaseButton2>
      <BaseButton2 :type="1">BaseButton2</BaseButton2>
      <BaseButton2 :type="1" :disabled="true">BaseButton2</BaseButton2>
      <BaseButton2 :type="2">BaseButton2</BaseButton2>
      <BaseButton2 :type="2" :disabled="true">BaseButton2</BaseButton2>
      <BaseButton2 :type="3">BaseButton2</BaseButton2>
      <BaseButton2 :type="3" :disabled="true">BaseButton2</BaseButton2>
      <BaseButton2 :type="4">BaseButton2</BaseButton2>
      <BaseButton2 :type="4" :disabled="true">BaseButton2</BaseButton2>
    </div>

    <div class="block">
      <BaseButton3>Base3Button</BaseButton3>
      <BaseButton3 :disabled="true">BaseButton3</BaseButton3>
      <BaseButton3 :type="1">BaseButton3</BaseButton3>
      <BaseButton3 :type="1" :disabled="true">BaseButton3</BaseButton3>
      <BaseButton3 :type="2">BaseButton3</BaseButton3>
      <BaseButton3 :type="2" :disabled="true">BaseButton3</BaseButton3>
      <BaseButton3 :type="3">BaseButton3</BaseButton3>
      <BaseButton3 :type="3" :disabled="true">BaseButton3</BaseButton3>
      <BaseButton3 :type="4">BaseButton3</BaseButton3>
      <BaseButton3 :type="4" :disabled="true">BaseButton3</BaseButton3>
    </div>

    <div class="block">
      <BaseButton4>BaseButton4</BaseButton4>
      <BaseButton4 :disabled="true">BaseButton4</BaseButton4>
      <BaseButton4 :type="1">BaseButton4</BaseButton4>
      <BaseButton4 :type="1" :disabled="true">BaseButton4</BaseButton4>
      <BaseButton4 :type="2">BaseButton4</BaseButton4>
      <BaseButton4 :type="2" :disabled="true">BaseButton4</BaseButton4>
      <BaseButton4 :type="3">BaseButton4</BaseButton4>
      <BaseButton4 :type="3" :disabled="true">BaseButton4</BaseButton4>
      <BaseButton4 :type="4">BaseButton4</BaseButton4>
      <BaseButton4 :type="4" :disabled="true">BaseButton4</BaseButton4>
    </div>

    <div class="block">
      <BaseButton5>BaseButton5</BaseButton5>
      <BaseButton5 :disabled="true">BaseButton5</BaseButton5>
      <BaseButton5 :type="1">BaseButton5</BaseButton5>
      <BaseButton5 :type="1" :disabled="true">BaseButton5</BaseButton5>
      <BaseButton5 :type="2">BaseButton5</BaseButton5>
      <BaseButton5 :type="2" :disabled="true">BaseButton5</BaseButton5>
      <BaseButton5 :type="3">BaseButton5</BaseButton5>
      <BaseButton5 :type="3" :disabled="true">BaseButton5</BaseButton5>
      <BaseButton5 :type="4">BaseButton5</BaseButton5>
      <BaseButton5 :type="4" :disabled="true">BaseButton5</BaseButton5>
    </div>

    <IconButton class="icon-dc_phone_icon_email_down"></IconButton>

    <MoreButton>展开</MoreButton>
    <MoreButton :disabled="true">展开</MoreButton>
    <BaseSwitch></BaseSwitch>
    <BaseSwitch :disabled="true"></BaseSwitch>
    <BaseSwitch :value="false" :disabled="true"></BaseSwitch>

    <CaseLabel :type="0">读书社区</CaseLabel>
    <CaseLabel :type="1">互动商务社交</CaseLabel>

    <ReplyLabel :type="0">读书社区</ReplyLabel>
    <ReplyLabel :type="1">互动商务社交</ReplyLabel>

    <BaseInput></BaseInput>
    <BaseInput
      icon="sign_password"
      :disabled="true" :placeholder="'请输入帐号'"
    ></BaseInput>
    <BaseInput
      icon="sign_prompt"
      :disabled="true" :value="'132332323'"
    ></BaseInput>
    <BaseInput
      icon="sign_password"
      :disabled="true" :value="'132332323'"
      unit="元"
    ></BaseInput>
    <BaseInput
      icon="sign_prompt" iconFloat="right"
      :disabled="true" :value="'132332323'"
    ></BaseInput>
    <BaseInput
      icon="sign_password" iconFloat="right"
      unit="元"
      :disabled="false" :value="'132332323'"
    ></BaseInput>

    <ResetPasswordForm></ResetPasswordForm>
    <SigninForm></SigninForm>
    <SignupForm></SignupForm>

    <ReadMoreText
      :text="'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero fuga facilis vel consectetur quos sapiente deleniti eveniet dolores tempore eos deserunt officia quis ab? Excepturi vero tempore minus beatae voluptatem!'"
    ></ReadMoreText>
    <div style="background-color:green">
      <BaseTip></BaseTip>
      <ModalTip>short</ModalTip>
      <ModalTip>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero fuga facilis vel consectetur quos sapiente deleniti eveniet dolores tempore eos deserunt officia quis ab? Excepturi vero tempore minus beatae voluptatem!</ModalTip>
      <QrcodeTip></QrcodeTip>
      <Close></Close>
    </div>
    <ErrorBlock style="height:50px;width:200px">abcde error</ErrorBlock>
    <Flow123></Flow123>
    <NumberCircle></NumberCircle>
    <NumberCircle :disabled="true"></NumberCircle>
    <BaseDropdown :data="[
      {value: 0, label: 'CEO'},
      {value: 1, label: 'CFO'},
      {value: 2, label: 'CTO'},
      {value: 0, label: 'CEO'},
      {value: 1, label: 'CFO'},
      {value: 2, label: 'CTO'}
    ]"></BaseDropdown>
    <UploadButton></UploadButton>
  </div>
</template>

<script>
import {
  BaseButton,
  BaseButton1,
  BaseButton2,
  BaseButton3,
  BaseButton4,
  BaseButton5,
  IconButton,

  MoreButton,
  UploadButton,

  BaseSwitch,

  CaseLabel,
  ReplyLabel,

  ResetPasswordForm,
  SigninForm,
  SignupForm,

  BaseInput,
  ReadMoreText,
  BaseTip,
  ModalTip,
  QrcodeTip,
  ErrorBlock,

  Close,
  Flow123,
  NumberCircle,
  BaseDropdown
} from '@/components'

export default {
  components: {
    BaseButton,
    BaseButton1,
    BaseButton2,
    BaseButton3,
    BaseButton4,
    BaseButton5,
    IconButton,

    MoreButton,
    UploadButton,
    BaseSwitch,

    CaseLabel,
    ReplyLabel,

    ResetPasswordForm,
    SigninForm,
    SignupForm,

    BaseInput,
    ReadMoreText,
    BaseTip,
    ModalTip,
    QrcodeTip,
    ErrorBlock,
    Close,
    Flow123,
    NumberCircle,
    BaseDropdown
  }
}
</script>

<style lang="postcss" scoped>
</style>



// WEBPACK FOOTER //
// src/AppTest.vue